export const generatePublicUrl = (fileName) => {
  return `https://mentorxdata-newbucket.s3.ap-south-1.amazonaws.com/${fileName}`;
};
export const generatePublicUrlLocal = (fileName) => {
  return `https://dev.mentorx4u.com/public/${fileName}`;
};
